import React, {useEffect} from 'react'
import Select from 'react-select'
import { useForm, Controller } from "react-hook-form";
import FormGroup from 'components/Form/FormGroup'
import FormImage from 'components/Form/FormImage'
import { useDispatch, useSelector } from 'react-redux';
import Spinner from "react-bootstrap/Spinner";
import FormBirthday from 'components/Form/FormBirthday'
import * as Yup from 'yup'
import moment from 'moment'
import "pages/userInformation.scss";
import Modal from 'react-bootstrap/Modal'
import {addNewClient} from 'store/actions/clientActions'
// import { values } from 'analytics/lib/analytics.cjs';

function NewClientModal(props) {

    // const { handleFormSubmission, isSaving } = props;
    const isSaving = useSelector(state => state.clients.isSaving)
    const savingError = useSelector(state => state.clients.savingError)
    const dispatch = useDispatch()

    const genders = ["Female", "Male", "Non-binary/genderqueer", "I prefer to self-identify", "Prefer not to say"]
    const genderOptions = genders.map(val => {return {value: val, label: val}})

    const { register, control, handleSubmit, setValue, getValues, formState, reset, errors } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            firstName: Yup.string().required('This field is required'),
            lastName: Yup.string().required('This field is required'),
            email: Yup.string().email("Please enter a valid email address").required('This field is required')
        }),
        // defaultValues: {
        //     firstName: user.firstName,
        //     lastName: user.lastName,
        //     email: user.email,
        //     phone: user.phone,
        //     birthday: user.birthday,
        //     gender: {label: user.gender, value: user.gender}
        //   }
    });

    const { dirty } = formState;

    const onSubmit = (data) => {
        if (data.gender) {
            data.gender = data.gender.value
        }

        dispatch(addNewClient(data)).then((result) => {
            // console.log("GREAT SUCCESS")
            props.onHide()
        }).catch((err) => {
            // console.log("AWH MAN")
        })
    }

    useEffect(() => {
        // register({ name: 'avatarImage'})
        register({ name: 'birthday' })
    }, [register])

    

    return (<>
    <Modal show={props.show || false} onHide={isSaving ? null : props.onHide} centered>
        <Modal.Header closeButton>
            <Modal.Title>Add a new client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {savingError && (
                <div className="alert alert-danger" role="alert">
                    {savingError}
                </div>
            )}
            <form className={"newClientForm" } onSubmit={handleSubmit(onSubmit)} noValidate={true}>
                {/* {errors && (
                    + " " + (Object.keys(errors).length > 0 ? "was-validated" : "needs-validation")
                    <div>
                        {JSON.stringify(errors)}
                    </div>
                )} */}

                <section>
                    <FormGroup
                    type="text"
                    name="firstName"
                    label="First name"
                    placeholder="Client first name"
                    register={register}
                    error={errors.firstName}
                    fullSize
                    />

                    <FormGroup
                    type="text"
                    name="lastName"
                    label="Last name"
                    placeholder="Client last name"
                    register={register}
                    error={errors.lastName}
                    fullSize
                    />  

                    <FormGroup
                    type="email"
                    name="email"
                    label="Email"
                    placeholder="Client email address"
                    register={register}
                    error={errors.email}
                    fullSize
                    /> 

                    <FormGroup
                    type="tel"
                    name="phone"
                    label="Phone"
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    placeholder="Client phone number"
                    register={register}
                    fullSize
                    />

                    <FormBirthday 
                    label="Birthday"
                    // birthday={user.birthday}
                    onChange={(val) => {
                        console.log(val)
                        setValue('birthday', val)
                    }}
                    fullSize
                    />

                    <FormGroup 
                    select
                    options={genderOptions}
                    type="select"
                    name="gender"
                    label="Gender"
                    placeholder="optional"
                    control={control}
                    getValues={getValues}
                    setValue={setValue}
                    fullSize
                    />

                    
                </section>

                <div className="d-flex justify-content-end">
                    {/* <button disabled={!dirty} type="submit" className="btn btn-primary">Add</button> */}
                    <button disabled={!dirty} type="submit" className="btn btn-primary">
                        
                        <span>{"Add"}</span>

                        {isSaving && (
                            <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                            >
                            <span className="sr-only">Saving...</span>
                            </Spinner>
                        )}
                    </button>
                </div>
            </form>
        </Modal.Body>
    </Modal>
    </>
    );
}

export default NewClientModal